import { render, staticRenderFns } from "./tabTrucking.vue?vue&type=template&id=0b981f02&scoped=true&"
import script from "./tabTrucking.vue?vue&type=script&lang=js&"
export * from "./tabTrucking.vue?vue&type=script&lang=js&"
import style0 from "./tabTrucking.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tabTrucking.vue?vue&type=style&index=1&id=0b981f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b981f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b981f02')) {
      api.createRecord('0b981f02', component.options)
    } else {
      api.reload('0b981f02', component.options)
    }
    module.hot.accept("./tabTrucking.vue?vue&type=template&id=0b981f02&scoped=true&", function () {
      api.rerender('0b981f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking.vue"
export default component.exports